export const apiClientConstants = {
  ID: 'id',

  REMOVE_CONFIRM: 'Are you sure?',

  API_CLIENT_NAME: 'name',
  API_CLIENT_NAME_LABEL: 'Name',

  API_CLIENT_GROUP: 'group_id',
  API_CLIENT_GROUP_LABEL: 'Access',

  API_TOKEN_NAME: 'name',
  API_TOKEN_NAME_LABEL: 'Name',

  API_TOKENS: 'tokens',
  API_TOKENS_LABEL: 'Tokens',

  API_ADD_TOKEN: 'Add Token',

  API_TOKEN_CLIENT: 'client_id',
  SEARCH_API_CLIENT: 'Search Api Clients',

  NEW_TOKEN:
    "New Tokens. COPY THEM NOW. YOU WON'T SEE THEM AGAIN AFTER YOU LEAVE THIS PAGE.",

  API_TOKEN_LAST_USED: 'last_used_at',
  API_TOKEN_LAST_USED_LABEL: 'Last Used',
  API_TOKEN_CREATED: 'created_at',
  API_TOKEN_CREATED_LABEL: 'Created',
};
